import { Accordion, Button, Icon, XStack, YStack } from '@shinetools/lumen-react'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFieldArray, useFormContext } from '../../../../../../../../../../../../hooks/useForm'
import type { SupplierFormSchema, SupplierFormValues } from '../../../../types/supplierForm'
import { getEmptyAdditionalContactPerson } from '../../../../utils/supplierForm'
import { AdditionalContactFields } from './elements/AdditionalContactFields'

export const AdditionalContact = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const { control } = useFormContext<SupplierFormSchema>()
  const { append, fields, remove } = useFieldArray<SupplierFormValues, 'additionalContactPersons'>({
    control,
    name: 'additionalContactPersons',
  })

  const handleAddContactClick = () => {
    append(getEmptyAdditionalContactPerson())
  }

  return (
    <Accordion onOpenChange={setIsOpen} open={isOpen} showDivider title={t('suppliers.detail.additional_contacts')}>
      <YStack gap={24}>
        {fields.map((field, index) => (
          <AdditionalContactFields index={index} key={field.id} onDeleteClick={() => remove(index)} />
        ))}
        <XStack justify="center">
          <Button
            label={t('suppliers.detail.additional_contacts.add_contact')}
            onClick={handleAddContactClick}
            size="small"
            startIcon={<Icon icon={Plus} size="small" />}
            variant="text"
          />
        </XStack>
      </YStack>
    </Accordion>
  )
}
